import AllianceBoard from "../AllianceBoard";
import AllianceOverview from "./Overview/AllianceOverview";
import AllianceStorage from "./Marketplace/AllianceStorage";
import Army from "./Army/Army";
import ArmyEmperorTent from "./Army/ArmyEmprorTent";
import Chat from "../Chat/Chat";
import ContentPopup from "../ContentPopup";
import Development from "./Development/Development";
import DevelopmentOverview from "./Overview/DevelopmentOverview";
import Generals from "./Generals/Generals";
import GeneralsOverview from "./Overview/GeneralsOverview";
import Headquarters from "./Headquarters/Headquarters";
import Labyrinth from "./Labyrinth/Labyrinth";
import LabyrinthResult from "./Labyrinth/LabyrinthResult";
import ChooseTreasure from "./Labyrinth/ChooseTreasure";
import Magic from "./Magic/Magic";
import MagicPlanner from "./Magic/MagicPlanner";
import MagicEmperorTent from "./Magic/MagicEmperorTent";
import Mail from "./Mail/Mail";
import Marketplace from "./Marketplace/Marketplace";
import News from "./News/News";
import OtherAllianceProfile from "./AllianceProfile/OtherAllianceProfile";
import OtherGovernorateProfile from "./GovernorateProfile/OtherGovernorateProfile";
import OverviewPalace from "./Overview/OverviewPalace";
import OwnAllianceProfile from "./AllianceProfile/OwnAllianceProfile";
import OwnGovernorateProfile from "./GovernorateProfile/OwnGovernorateProfile";
import Statistics from "./Statistics/Statistics";
import Thieves from "./Thieves/Thieves";
import ThievesEmperorTent from "./Thieves/ThievesEmperorTent";

export const contents = {
  AllianceBoard,
  AllianceOverview,
  AllianceStorage,
  Army,
  ArmyEmperorTent,
  Chat,
  ContentPopup,
  Development,
  DevelopmentOverview,
  Generals,
  GeneralsOverview,
  Headquarters,
  ChooseTreasure,
  Labyrinth,
  LabyrinthResult,
  Magic,
  MagicEmperorTent,
  MagicPlanner,
  Mail,
  Marketplace,
  News,
  OtherAllianceProfile,
  OtherGovernorateProfile,
  OverviewPalace,
  OwnAllianceProfile,
  OwnGovernorateProfile,
  Statistics,
  Thieves,
  ThievesEmperorTent
};
